import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { selectQrModalStatus } from "../../../store/supervisorRequiredDocuments/selectors/selectQrModalStatus";
import { resetDocumentList, setModalQrStatus } from "../../../store/supervisorRequiredDocuments";
import { selectQRScannerStatus } from "../../../store/qrScanner/selectors/selectQRScannerStatus";
import { selectQRCode } from "../../../store/qrScanner/selectors/selectQRCode";
import { useDispatch, useSelector } from "react-redux";
import { arrowBackOutline, camera } from "ionicons/icons";
import { usePhotoGallery } from "./cameraAccess";
import { useEffect } from "react";
import { UserPhoto } from "../../../@types/usePhotoGallery";
import { sendPhoto } from "../../../store/supervisorRequiredDocuments/actions/sendPhoto";
import { fetchHojasDeCargo } from "../../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";

export const QrModalDialog = () => {
  const dispatch = useDispatch();

  const { photos, takePhoto, photoInfo } = usePhotoGallery();

  const modalStatus = useSelector(selectQrModalStatus);

  const qrCode = useSelector(selectQRCode);

  const qrStatus = useSelector(selectQRScannerStatus);

  const codeIsHc = qrCode.includes("hc");

  const [presentToast, hideToast] = useIonToast();

  const handleSendNotificationTest = async (photos: UserPhoto[]) => {
    try {
      await hideToast();
      presentToast({
        message: `Cargando Archivo...`,
        color: "primary",
      });
      const { payload: notificationCreated }: any = await dispatch(sendPhoto(photos));
      if (!notificationCreated) {
        throw new Error("No se pudo cargar el archivo");
      }

      await hideToast();
      dispatch(resetDocumentList());
      dispatch(fetchHojasDeCargo());
      presentToast({
        message: `Se cargo correctamente el archivo`,
        color: "success",
        duration: 8000,
      });
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema al enviar el archivo",
        color: "danger",
        duration: 8000,
      });
    }
  };

  useEffect(() => {
    if (photos.length > 0) {
      handleSendNotificationTest(photos);
    }
  }, [photos]);

  return (
    <IonModal isOpen={modalStatus} onWillDismiss={() => dispatch(setModalQrStatus(false))}>
      <IonToolbar>
        <IonTitle>
          <IonIcon
            className="btn-close"
            icon={arrowBackOutline}
            onClick={() => dispatch(setModalQrStatus(false))}
          />
          {codeIsHc ? "Cargar Hoja de Cargo: " + qrCode : "Cargar Hoja de Cargo:"}
        </IonTitle>
      </IonToolbar>
      <IonContent>
        <h4 className="ion-padding-start">
          <IonText>
            {codeIsHc ? "Opciones" : "El codigo QR no corresponde a una hoja de cargo valida."}
          </IonText>
        </h4>
        <IonItem>
          {codeIsHc ? (
            <>
              <IonLabel>
                <h2 style={{ fontWeight: 500 }}>Subir Foto de Hoja de Cargo</h2>
              </IonLabel>
              <IonButtons slot="end">
                <IonButton fill="solid" color="primary" onClick={() => takePhoto(10)}>
                  <IonIcon icon={camera} style={{ marginRight: 3 }} />
                  <IonText className="ion-hide-md-down">Foto</IonText>
                </IonButton>
              </IonButtons>
            </>
          ) : (
            <>
              <IonLabel>
                <h2 style={{ fontWeight: 500 }}>No se pudo validar el codigo QR</h2>
              </IonLabel>
              <IonButtons slot="end">
                <IonButton
                  onClick={() => {
                    dispatch(setModalQrStatus(false));
                  }}
                  fill="solid"
                  color="primary"
                >
                  <span>Volver</span>
                </IonButton>
              </IonButtons>
            </>
          )}
        </IonItem>
      </IonContent>
    </IonModal>
  );
};
